function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M145 0H98.5167C94.3653 0 91 3.36533 91 7.51667C91 11.668 94.3653 15.0333 98.5167 15.0333H130.24V47.62C130.24 51.6958 133.544 55 137.62 55C141.696 55 145 51.6958 145 47.62V0Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.14577e-06L2.03185e-06 46.4833C2.21331e-06 50.6347 3.36533 54 7.51667 54C11.668 54 15.0333 50.6347 15.0333 46.4833L15.0333 14.7601L47.62 14.7601C51.6958 14.7601 55 11.4559 55 7.38003C55 3.30415 51.6958 -1.1393e-07 47.62 6.42325e-08L0 2.14577e-06Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.50618e-06 145H46.4833C50.6347 145 54 141.635 54 137.483C54 133.332 50.6347 129.967 46.4833 129.967H14.7601L14.7601 97.38C14.7601 93.3042 11.4559 90 7.38003 90C3.30415 90 -1.32125e-08 93.3042 3.43112e-07 97.38L4.50618e-06 145Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M145 145V98.5167C145 94.3653 141.635 91 137.483 91C133.332 91 129.967 94.3653 129.967 98.5167V130.24H97.38C93.3042 130.24 90 133.544 90 137.62C90 141.696 93.3042 145 97.38 145H145Z"
});

function SvgEnterFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterFullscreen);
export default __webpack_public_path__ + "static/media/enter_fullscreen.2d0f57b3.svg";
export { ForwardRef as ReactComponent };